import { autoinject, transient } from "aurelia-dependency-injection";
import { RightShipDialogServiceConstants } from "../../../../../../constants/basics/rightship-dialog.constants";
import { DialogClientService } from "@rightship-tech/common-ui/services/basic/dialog-client.service";
import { DataGrid } from "../../../../../components/data-grid/data-grid";

@autoinject
@transient()
export class BusinessUnitAddRuleCollectionsDialog 
{
    public model: BusinessUnitAddRuleCollectionsDialogModel;

    constructor(private dialogClientService: DialogClientService) {
    }

    /**
     * Close the form dialog
     */
    close = () => {
        this.dialogClientService.hide();
    }

    activate(model: { businessUnitId: number, dataGrid: DataGrid }){
        if(model)
        {
            this.model =  { 
                businessUnitId: model.businessUnitId,
                dataGrid: model.dataGrid,
                onSubmit: this.close
            };
        }
    }

    addRuleCollectionType(x: number) {
        if(x == 1) { //Link global rule collection
            this.dialogClientService.show(RightShipDialogServiceConstants.URLs.LinkRuleCollectionsToBuDialog, this.model, true, true, false, 'right');
        }
        else if(x == 2){ //Add custom rule collections
            this.dialogClientService.show(RightShipDialogServiceConstants.URLs.AddRulesCollectionDialog, this.model, true, true, false, 'right');
        }
    }
}

export interface BusinessUnitAddRuleCollectionsDialogModel
{
    businessUnitId: number;
    dataGrid: DataGrid;
    onSubmit: () => void;
}